// The sections a dispatch shows, in reading order — one list every surface
// renders (the reader, the email, the markdown twin), so the three cannot
// disagree about what an edition contains.
//
// Since 2026-09-23 an edition is divided by expansion zone — where the product
// grew — with the small fixes kept to one quiet line at the end. Older editions
// carry the status sections (shipped · smoothed · in flight · worth noticing);
// they still render, after any zones, exactly as they always did.

import type { DispatchData, DispatchItem } from './types';

export interface DispatchSection {
  key: string;
  label: string;
  /** the zone's one-sentence summary, shown under its label. */
  line?: string;
  items: DispatchItem[];
  /** the "also" line — rendered small, a footnote rather than a section. */
  aside?: boolean;
}

const LEGACY: [keyof DispatchData, string][] = [
  ['shipped', 'shipped'],
  ['fixed', 'smoothed'],
  ['in_flight', 'in flight'],
  ['notes', 'worth noticing'],
];

export function dispatchSections(d: DispatchData): DispatchSection[] {
  const out: DispatchSection[] = [];
  for (const [i, z] of (Array.isArray(d.zones) ? d.zones : []).entries()) {
    const items = Array.isArray(z?.items) ? z.items : [];
    if (!z?.zone || (!z.line && items.length === 0)) continue;
    out.push({ key: `zone-${i}`, label: z.zone, ...(z.line ? { line: z.line } : {}), items });
  }
  for (const [key, label] of LEGACY) {
    const items = d[key] as DispatchItem[] | undefined;
    if (Array.isArray(items) && items.length > 0) out.push({ key, label, items });
  }
  if (d.also) out.push({ key: 'also', label: 'also, quietly', line: d.also, items: [], aside: true });
  return out;
}
